import React, {Component} from 'react';
import {ListGroup} from 'reactstrap';
import connect from 'react-redux/es/connect/connect';
import InfiniteScroll from 'react-infinite-scroll-component';
import Select from "react-select";

import DefaultLayout from '../Layout/DefaultLayout.jsx';
import Loader from '../../../shared/components/Loader/Loader.jsx';
import mustBeLogged from '../../components/Must/MustBeLogged.jsx';
import mustHaveAcceptedCGU from '../../components/Must/MustHaveAcceptedCGU.jsx';
import Notification from '../../components/Notifications/components/Notification.jsx';

import api from '../../../api.js';
import {loadUniverseById} from '../../components/UniverseLoader/actions.js';

import './NotificationsPage.scss';

const notificationsLimit = 20;

class NotificationsPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      infiniteLoading: false,
      markingAsSeen: false,
      notifications: [],
      universes: [],
      selectedUniverse: this.props.currentUniverseId ? this.props.currentUniverseId : this.props.userMainUniverseId,
      hasMore: true
    };
  }

  componentDidMount = async () => {
    await this.fetchUniverses()
    await this.loadNotifications(this.state.selectedUniverse);
    this.setState({loading: false});

    if (!this.props?.userUniverses.includes(this.props?.currentUniverseId) && this.props?.userMainUniverseId !== null) {
      this.props.loadUniverseById(this.props.userMainUniverseId);
    }
  }

  componentDidUpdate = async (prevProps, prevState, prevContext) => {
    if (this.props.currentUniverseId !== prevProps.currentUniverseId) {
      this.setState({
        hasMore: true,
        loading: true,
        selectedUniverse: this.props.currentUniverseId
      });
      await this.loadNotifications(this.props.currentUniverseId);
      this.setState({loading: false})
    }
  }

  loadNotifications = async (universe, existingNotifications = [], reload = false) => {
    this.setState({infiniteLoading: true});
    const nbNotifications = existingNotifications.length;
    const notifications = [];

    await api.notifications.getMy({
      universe: universe,
      page: reload ? 1 : Math.floor(existingNotifications.length / notificationsLimit) + 1,
      limit: reload ? nbNotifications : notificationsLimit
    }).then(response => {
      if (response.data.items.length) {
        response.data.items.forEach(item => {
          notifications.push(
            <Notification
              key={`notification-${item.id}`}
              notification={item}
              loadNotification={this.loadNotifications}
            />
          );
        });
        if (response.data.items.length < notificationsLimit) {
          this.setState({hasMore: false});
        }
      } else {
        this.setState({hasMore: false});
      }
    });

    this.setState({
      notifications: reload ? notifications : existingNotifications.concat(notifications),
      infiniteLoading: false
    });
  };

  handleInfiniteLoad = async () => {
    if (this.state.hasMore && !this.state.infiniteLoading && !this.state.markingAsSeen) {
      await this.loadNotifications(this.state.selectedUniverse, this.state.notifications);
    }
  };

  elementInfiniteLoad = () => {
    return <Loader visible={this.state.infiniteLoading} fill={false} className="infinite-list-item">
      Loading...
    </Loader>;
  };

  markAllAsSeen = async () => {
    this.setState({markingAsSeen: true});
    await api.notifications.markAsSeen({universe: this.props.currentUniverseId });
    await this.loadNotifications(this.state.selectedUniverse, this.state.notifications, true);
    this.setState({markingAsSeen: false});
  };

  fetchUniverses = async () => {
    await api.universes.getAll()
      .then((response)=> {
        if(response.data) {
          this.setState({universes: response.data})
        }
      })
      .catch((error) => {
        console.error({error})
      })
  }

  onSelectUniverseChange = (universe) => {
    const value = universe.value
    this.setState({selectedUniverse: value})
    this.loadNotifications(value)
  }

  render() {

    const {universes, selectedUniverse} = this.state

    const availableUniversesOptions = universes.map((universe) => {return {value: universe.id, label: universe.name}});

    return (
      <DefaultLayout showSidebarMenu={false}>
        <div className="bg-gray-50 print-no-color">
          <div className="container container-notifications">
            <div className="row">
              <div className="mx-auto col bg-white bd-gray-200 print-no-border notifications">
                <div className="d-flex justify-content-between align-items-center notifications-header">
                  <h1>Notifications</h1>

                  <div style={{maxWidth: 200, width: '100%', marginInline: 'auto'}}>
                    <Select
                      value={selectedUniverse}
                      name="univers"
                      onChange={this.onSelectUniverseChange}
                      options={availableUniversesOptions}
                      placeholder="Choisissez un univers"
                      style={{maxWidth: 200, width: '100%', marginInline: 'auto'}}
                      clearable={false}
                    />
                  </div>

                  <button className="btn btn-primary" onClick={this.markAllAsSeen}>
                    Tout marquer comme lu
                  </button>
                </div>
                {this.state.loading ?
                  <Loader visible={this.state.loading} fill={false} className="infinite-list-item">
                    Loading...
                  </Loader> :
                  this.state.notifications.length ?
                    <InfiniteScroll
                      dataLength={this.state.notifications.length} // Nombre d'éléments actuels
                      next={this.handleInfiniteLoad} // Fonction pour charger plus d'éléments
                      hasMore={this.state.hasMore} // Indique s'il y a encore des éléments à charger
                      loader={this.elementInfiniteLoad()} // Affiche un loader pendant le chargement
                      scrollThreshold={0.8} // Charge plus d'éléments à 80% du scroll
                    >
                      <ListGroup className="notifications-list">
                        {this.state.notifications}
                      </ListGroup>
                    </InfiniteScroll> :
                    <p>Aucune notification</p>
                }
              </div>
            </div>
          </div>
        </div>
      </DefaultLayout>
    );
  }
}

export default connect(
  state => ({
    userUniverses: state.currentUser?.user?.universes?.length ? state.currentUser?.user?.universes : [],
    userMainUniverseId: state.currentUser?.user?.mainUniverse ?? null,
    currentUniverseId: state.universe?.currentUniverse?.id ?? null
  }),
  (dispatch) => ({
    loadUniverseById: (universeId) => dispatch(loadUniverseById(universeId))
  })
)(mustBeLogged(mustHaveAcceptedCGU(NotificationsPage)));
